<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Envio de Template</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <form @submit.prevent="emitirEnvio" class="space-y-4">
                  <!-- Select de templates -->
                  <div class="flex flex-col">
                    <h2>
                    📌 O que são templates?
                    Templates são mensagens prontas e autorizadas pelo WhatsApp.
                    Eles servem para retomar o contato com o cliente depois de 24 horas sem resposta.

                    ➡️ Selecione um modelo abaixo, preencha os campos (se aparecerem) e clique em Enviar Template.

                    Assim você mantém o atendimento fluindo, mesmo com clientes que demoram a responder.
                  </h2>
                    <label for="template" class="text-sm font-medium text-gray-700">template</label>
                    <select
                      id="template"
                      v-model="templateSelecionadoId"
                      class="mt-1 border border-gray-300 rounded-md px-3 py-2"
                    >
                      <option disabled value="">selecione um template</option>
                      <option
                        v-for="tpl in templates"
                        :key="tpl.id"
                        :value="tpl.id"
                      >
                        {{ tpl.name }}
                      </option>
                    </select>
                  </div>
                  <!-- Descrição do template -->
                  <div v-if="templateSelecionado" class="text-sm text-gray-500 italic">
                    {{ templateSelecionado.description }}
                  </div>

                  <!-- Se houver variáveis manuais, mostrar inputs -->
                  <div
                    v-for="variavel in variaveisManuais"
                    :key="variavel.id"
                    class="flex flex-col"
                  >
                    <label :for="variavel.key" class="text-sm font-medium text-gray-700">
                      {{ variavel.key }}
                      <span v-if="variavel.is_required" class="text-red-500">*</span>
                    </label>

                    <input
                      v-if="variavel.key.toLowerCase() === 'data'"
                      type="date"
                      :id="variavel.key"
                      v-model="valores[variavel.key]"
                      :required="variavel.is_required"
                      class="mt-1 border border-gray-300 rounded-md px-3 py-2"
                    />

                    <input
                      v-else-if="variavel.key.toLowerCase() === 'horario'"
                      type="time"
                      :id="variavel.key"
                      v-model="valores[variavel.key]"
                      :required="variavel.is_required"
                      class="mt-1 border border-gray-300 rounded-md px-3 py-2"
                    />

                    <input
                      v-else
                      type="text"
                      :id="variavel.key"
                      v-model="valores[variavel.key]"
                      :required="variavel.is_required"
                      class="mt-1 border border-gray-300 rounded-md px-3 py-2"
                      :placeholder="variavel.example || ''"
                    />
                  </div>

                  <!-- Mensagem se não tiver campos -->
                  <div v-if="templateSelecionado && variaveisManuais.length === 0" class="text-gray-500 italic">
                    este template não precisa de preenchimento manual.
                  </div>

                  <!-- Botão de envio -->
                  <button
                    type="submit"
                    :disabled="!templateSelecionado"
                    class="w-full px-4 py-2 rounded-md bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-50"
                  >
                    Enviar Template
                  </button>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

  export default {
    name: 'AtendimentosWhatsAppTemplateForm',
    async created(){
        
    },
    props: {
      open: {
        type: Boolean,
        required: true
      },
      templates: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        data: {},
        templateSelecionadoId: '',
        valores: {},
      };
    },
    methods: {
      emitirEnvio() {
        this.data = {
          template_name: this.templateSelecionado.name,
          valores: this.valores
        }
        this.$emit('enviar-template', this.data)
      },
      closeDialog() {
        this.$emit('update-open', false);
      }
    },
    computed: {
      templateSelecionado() {
        return this.templates.find(t => t.id === this.templateSelecionadoId) || null
      },
      variaveisManuais() {
        if (!this.templateSelecionado?.variables) return []
        return this.templateSelecionado.variables.filter(
          v => v.value_source === 'manual'
        )
      }
    },
    watch: {
      templateSelecionado() {
        this.valores = {}
        this.variaveisManuais.forEach(v => {
          this.valores[v.key] = v.example || ''
        })
      }
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot
    },
  }
</script>